/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.maxHeight{max-height:calc(100vh - 238px);overflow-y:auto}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #e9ecef}.table td,.table th{padding:3px}.table-bordered td{border:none}.table-bordered td a i{font-size:32px;color:#ffb000}.table-bordered td a img{width:40px;height:40px}"];
export { styles as styles };
